import { PageHeader } from '@cxc/react-fpds-components';
import { createSuperScriptLinkHtml } from '../SuperScriptLink/SuperScriptLink';
import ReactHtmlParser from 'react-html-parser';

const Header = () => {
    const description = (
        <div id="feature-text">
            Search for publicly available incentives
            <sup>{ReactHtmlParser(createSuperScriptLinkHtml())}</sup> may that may reduce the cost
            of electric vehicles and charging equipment.
        </div>
    );

    return (
        <PageHeader
            titleProp={{
                title: 'Public Electrification Incentives',
                size: 'extraLarge',
                headingLevel: 'h1',
            }}
            description={description}
            hideBackground={true}
        />
    );
};

export default Header;
